import {gql} from '@apollo/client'

export const GET_INVOICE = gql`
  query GetInvoice($invoiceId: ID!) {
    invoice(id: $invoiceId) {
      id
      account {
        id
        displayName @client
        name
        contactFirstName
        contactLastName
        contactAddress
        contactEmail
        billingEmail
        customerNumber
      }
      invoiceNumber
      reference
      date
      dueDate
      xeroLink
      billTo
      isSendable
      state
      isSent
      lineItems
      taxType
      email
      debits {
        id
        description
        amount
        date
      }
      credits {
        id
        description
        amount
        date
      }
    }
  }
`

export const CREATE_INVOICE = gql`
  mutation CreateInvoice(
    $taxType: String
    $date: String
    $dueDate: String
    $isSendable: Boolean
    $accountId: ID
    $reference: String
    $billTo: String
    $lineItems: JSON
  ) {
    invoice(
      taxType: $taxType
      date: $date
      dueDate: $dueDate
      isSendable: $isSendable
      accountId: $accountId
      reference: $reference
      billTo: $billTo
      lineItems: $lineItems
    ) {
      id
      account {
        id
        displayName @client
        name
        contactFirstName
        contactLastName
        contactAddress
        contactEmail
        billingEmail
        customerNumber
      }
      invoiceNumber
      reference
      date
      dueDate
      xeroLink
      billTo
      isSendable
      state
      isSent
      lineItems
      taxType
      email
    }
  }
`

export const UPDATE_INVOICE = gql`
  mutation UpdateInvoice(
    $invoiceId: ID!
    $taxType: String
    $date: String
    $dueDate: String
    $isSendable: Boolean
    $accountId: ID
    $reference: String
    $billTo: String
    $lineItems: JSON
    $email: JSON
    $state: String
  ) {
    invoice(
      id: $invoiceId
      taxType: $taxType
      date: $date
      dueDate: $dueDate
      isSendable: $isSendable
      accountId: $accountId
      reference: $reference
      billTo: $billTo
      lineItems: $lineItems
      email: $email
      state: $state
    ) {
      id
      taxType
      date
      dueDate
      isSendable
      account {
        id
        name
        displayName @client
        contactFirstName
        contactLastName
        contactAddress
        contactEmail
        billingEmail
        customerNumber
      }
      reference
      billTo
      state
      lineItems
      email
    }
  }
`

export const SEND_INVOICE_EMAIL = gql`
  mutation SendInvoiceEmail(
    $invoiceId: ID!
    $to: String
    $cc: String
    $bcc: String
    $subject: String
    $message: String
  ) {
    invoice: sendInvoiceEmail(
      invoiceId: $invoiceId
      to: $to
      cc: $cc
      bcc: $bcc
      subject: $subject
      message: $message
    ) {
      id
      email
    }
  }
`
